import { showWhatAreYouWatchingBottomSheetAction } from "@src/components/BottomSheets/store/actions";
import { getAwsAssets } from "@src/utils/index";
import { t } from "i18next";
import { useRouter } from "@src/lib/router";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import getFeaturedVideo from "../../helpers/getFeaturedVideo";
import {
  getFreeCourseContentAction,
  getTrialCourseContentAction,
  geTrialCourseContentLoadMoreAction
} from "../../store/actions";
import { CONTENT_LIMIT } from "../../store/constants";
import styles from "../../styles/ContentHome.module.scss";
import {
  funnelTrackAction,
  funnelTrackHistoryObjectAction,
  getCourseDetailsAction,
} from "@src/components/Tabs/Overview/store/actions.js";
import { trackIDMap } from "../../../Overview/store/constants";
import { COURSE_TABS_ENUMS } from "@src/utils/constants";
import { newWebEngage } from "@src/utils/webEngageEvent";
import { safeJsonParse } from "@src/utils/safeJsonParse";

import ContentList from "../ContentList";
import Input from "@src/components/UIElements/Input";

const TrialContent = ({ folderId, folderRoute }) => {
  // STATE FOR SEARCH INPUT VALUE
  const prevSearchInputValue = React.useRef("");
  const [searchInputValue, setSearchInputValue] = React.useState("");

  // NEXTJS ROUTER
  const router = useRouter();

  // REDUX DISPATCH
  const dispatch = useDispatch();

  // FETCHING STATES FROM REDUCER
  const contentList = useSelector(
    (state) => state?.courseContentReducer?.apiResGET_TRIAL_COURSE_CONTENT
  );
  const contentLoading = useSelector(
    (state) => state?.courseContentReducer?.loadingStateGET_TRIAL_COURSE_CONTENT
  );
  const contentHasMore = useSelector(
    (state) => state?.courseContentReducer?.hasMoreGET_TRIAL_COURSE_CONTENT
  );
  const contentListLastOffset = useSelector(
    (state) => state?.courseContentReducer?.lastOffsetGET_TRIAL_COURSE_CONTENT
  );
  const contentListLength = useSelector(
    (state) => state?.overviewReducer?.overViewDetails?.course?.resourceCount
  );
  const currentFolderId = useSelector(
    (state) =>
      state?.courseContentReducer?.currentFolderGET_TRIAL_COURSE_CONTENT?.folderId
  );
  const currentFolderName = useSelector(
    (state) =>
      state?.courseContentReducer?.currentFolderGET_TRIAL_COURSE_CONTENT?.folderName
  );
  const trialContentTabId = useSelector(
    (state) =>
      state?.tabBarReducer?.tabList?.find?.(
        (tab) => tab?.enumKey === COURSE_TABS_ENUMS.TRIAL_CONTENT
      )?.id
  );
  console.log({trialContentTabId})
  const state = useSelector((state) => {
    state?.overviewReducer?.overViewDetails?.course;
  });
  const funnelTrackObj = useSelector(
    (state) => state?.overviewReducer?.funnelTrackingHistoryObject
  );
  const isPullToRefreshTriggered = useSelector(
    (state) => state?.pullToRefreshReducer?.isPullToRefreshTriggered
  );

  // FETCHING CONTENT WHEN TAB ID IS EQUAL TO CONTENT ID
  React.useEffect(() => {
    console.log({router})
    if (
      router?.query?.tabId == trialContentTabId &&
      (!contentList.length || currentFolderId !== null)
    ) {
      handleFetchTrialContent(contentList?.length && !currentFolderName);
    }
  }, [router?.query?.tabId, trialContentTabId]);

  // HANDLING PULL TO REFRESH ACTION
  React.useEffect(() => {
    if (isPullToRefreshTriggered) {
      refreshCourseContent(true);
    }
  }, [isPullToRefreshTriggered]);

  // FETCHING CONTENT WHEN FOLDER ID CHANGES
  React.useEffect(() => {
    folderId && handleFetchTrialContent();
  }, [router?.query?.folderId]);

  // FETCHING CONTENT WHEN SEARCH VALUE CHANGES
  React.useEffect(() => {
    prevSearchInputValue.current !== searchInputValue && handleContentSearch();
  }, [searchInputValue]);
  React.useEffect(() => {
    if (!funnelTrackObj?.contentList) {
      // console.log(funnelTrackObj);
      dispatch(
        funnelTrackAction({
          type: trackIDMap.contentList,
          isPurchased:
            state?.installments?.paidInstallmentSummary?.isPaymentComplete ===
              1 || state?.metaData?.isPurchased === 1,
          courseId: router?.query?.courseId,
        })
      );
      dispatch(funnelTrackHistoryObjectAction({ contentList: true }));
    }
    if (router?.query?.tabId == trialContentTabId) {
      newWebEngage("course_content_tab_click", {
        action: "Content Tab Click",
        screen_name: "",
      });
    }
    return () => clearTimeout(debounceTimer.current);
  }, []);

  // DEBOUNCE TIMER REF
  const debounceTimer = React.useRef(null);
  // DISPATCHING ACTION TO SEARCH CONTENT
  const handleContentSearch = () => {
    clearTimeout(debounceTimer.current);
    debounceTimer.current = setTimeout(() => handleFetchTrialContent(), 300);
  };

  // CATCHING EVENT REFRESH COURSE CONTENT ON TEST/VIDEO CLOSE ON NATIVE APP
  React.useEffect(() => {
    window.onPlayerClose = (dataObj) => {
      const parsedJSON = safeJsonParse(dataObj, {
        source: "TrialContent [onPlayerClose]",
        fallback: {},
      });
      if (parsedJSON?.PARAM_SAMPLING_ENABLED) {
        dispatch(showWhatAreYouWatchingBottomSheetAction(true));
      }
      if (router?.query?.tabId == trialContentTabId || router?.query?.folderId) {
        refreshCourseContent();
      } else {
        dispatch(
          getCourseDetailsAction({
            courseId: router?.query?.courseId,
            isLoading: false,
          })
        );
        dispatch(
          getFreeCourseContentAction({
            courseId: router?.query?.courseId,
            offset: 0,
            skipLoader: true,
            limit: contentListLastOffset + CONTENT_LIMIT,
          })
        );
      }
    };
    window.onTestAttempted = () => {
      if (router?.query?.tabId == trialContentTabId || router?.query?.folderId) {
        refreshCourseContent();
      } else {
        dispatch(
          getCourseDetailsAction({
            courseId: router?.query?.courseId,
            isLoading: false,
          })
        );
        dispatch(
          getTrialCourseContentAction({
            courseId: router?.query?.courseId,
            isLoading: false,
          })
        );
        dispatch(
          getFreeCourseContentAction({
            courseId: router?.query?.courseId,
            offset: 0,
            skipLoader: true,
            limit: contentListLastOffset + CONTENT_LIMIT,
          })
        );
      }
    };
  });

  // FUNCTION TO DISPATCH ACTION TO REFRESH COURSE CONTENT ON TEST/VIDEO CLOSE
  const refreshCourseContent = (isPullToRefreshAction = false) => {
    // dispatch(
    //   getCourseContentAction({
    //     courseId: router.query.courseId,
    //     limit: contentListLastOffset + CONTENT_LIMIT,
    //     folderId: router?.query?.folderId,
    //     skipLoader: true,
    //     search: searchInputValue,
    //     isPullToRefreshAction: isPullToRefreshAction,
    //   })
    // );

    dispatch(
      getTrialCourseContentAction({
        courseId: router.query.courseId,
        limit: contentListLastOffset + CONTENT_LIMIT,
        folderId: router?.query?.folderId,
        skipLoader: true,
        search: searchInputValue,
        isPullToRefreshAction: isPullToRefreshAction,
      })
    );
  };

  // FUNCTION TO DISPATCH ACTION TO FETCH COURSE CONTENT
  const handleFetchTrialContent = (skipLoader) => {
    dispatch(
      getTrialCourseContentAction({
        courseId: router.query.courseId,
        limit: CONTENT_LIMIT,
        folderId: router?.query?.folderId,
        skipLoader: skipLoader,
        search: searchInputValue,
        originalCourseId: router?.query?.originalCourseId,
      })
    );
  };

  // HANDLE LOAD MORE CONTENT WHEN USER REACHES END OF LIST
  const handleLoadMoreContent = () => {
    dispatch(
      geTrialCourseContentLoadMoreAction({
        courseId: router.query.courseId,
        offset: contentListLastOffset + CONTENT_LIMIT,
        folderId: router?.query?.folderId || 0,
        limit: CONTENT_LIMIT,
        search: searchInputValue,
      })
    );
  };

  // HANDLING ON CHANGE FOR SEARCH INPUT
  const handleInputChange = (e) => {
    prevSearchInputValue.current = searchInputValue;
    setSearchInputValue(e.target.value);
  };

  // GETTING FEATURED VIDEO FROM THE CONTENT LIST
  const featuredVideo = getFeaturedVideo(contentList);

  // GET CONTENT LIST HEADING BASED ON SOME CHECKS
  const getContentListHeading = () => {
    if (folderRoute) return null;
    if (!contentListLength) return null;
    else if (contentListLength > 1)
      return `${contentListLength} ${t(
        "components.tabs.content.components.contentHome.index.studyMaterialTextPlural",
        "Study Materials"
      )}`;
    return `${contentListLength} ${t(
      "components.tabs.content.components.contentHome.index.studyMaterialTextSingular",
      "Study Material"
    )}`;
  };

  return (
    <div className={styles.contentHome}>
      <div
        className={`${styles.contentHome__searchBar} ${
          folderRoute && styles["contentHome__searchBar--folderRoute"]
        }`}
      >
        <Input
          icon={getAwsAssets("searchIcon.svg", "content")}
          type="name"
          placeholder={t(
            `components.tabs.content.components.contentHome.index.searchContentPlaceholder`,
            "Search content"
          )}
          value={searchInputValue}
          onChange={handleInputChange}
        />
      </div>
      <div className={styles.contentHome__content}>
        <ContentList
          contentHeading={getContentListHeading()}
          featuredVideo={featuredVideo}
          contentList={contentList}
          contentListLength={folderRoute ? 0 : contentListLength}
          contentLoading={contentLoading}
          contentHasMore={contentHasMore}
          handleLoadMoreContent={handleLoadMoreContent}
          noContentText={t(
            `components.tabs.content.components.contentHome.index.noContentScreenHeading`,
            `No content here!`
          )}
          subtext={t(
            `components.tabs.content.components.contentHome.index.noContentSubtext`,
            `Looks like we created this folder in a hurry! Go back and continue learning.`
          )}
          isTrialContent={true}
        />
      </div>
    </div>
  );
};

export default TrialContent;
